export default "__VITE_ASSET__CtFwQGwa__"